import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-navbar',
  templateUrl: './mini-navbar.component.html',
  styleUrls: ['./mini-navbar.component.css']
})
export class MiniNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
